import React, { FC } from 'react';
import AppLayout from '@amzn/meridian/app-layout';
import AgileNavBar from '@components/agile/navigation/AgileNavBar';

interface Props {
  children?: React.ReactNode;
}

const AgileLayout: FC<Props> = ({ children }) => (
  <AppLayout headerComponent={AgileNavBar} backgroundColor="primary">
    <AgileNavBar />
    {children}
  </AppLayout>
);

export default AgileLayout;
